import { RandomEngine } from '@grandom/core';
export default class MathRandomEngine extends RandomEngine {
    constructor() {
        super('math-random');
    }
    _next() {
        return Math.random();
    }
}
//# sourceMappingURL=index.js.map